import { Component, OnInit, Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ODSService} from 'app/main/pagina/tools/gestUsu/services/ods.service';
import {OdsV2Service} from 'app/main/pagina/tools/gestUsu/ods-v2/ods-v2.service';
import { lang_conteos } from 'app/idiomas/i18n/Conteos/conteos.lang';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_ods } from 'app/idiomas/i18n/ods-v2/ods.lang';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators} from '@angular/forms';
import { lang_avances } from 'app/idiomas/i18n/avances/avances.lang';
import Swal from 'sweetalert2';
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {MatPaginator} from '@angular/material/paginator';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import * as catCamposGoFlow from "./catalogoColumnas";
import { fuseAnimations } from '@fuse/animations';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { DateAdapter } from '@angular/material/core';
const moment = require('moment');
const momentTz = require('moment-timezone');
import { zonasUTC } from 'app/main/pagina/zonasUtc';

import { CdkDragDrop, CdkDrag, moveItemInArray } from "@angular/cdk/drag-drop";
import { Observable } from "rxjs";
;
import { transferArrayItem} from '@angular/cdk/drag-drop';
import * as i0 from "@angular/core";

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
];
let globalLimitPuntos=10;

@Component({
  selector: 'app-config-result',
  templateUrl: './config-result.component.html',
  styleUrls: ['./config-result.component.scss'],
  animations : fuseAnimations
})

export class ConfigResultComponent implements OnInit {
  todo = [
     {
       name: "Pictures",
       extension: ""
     },
     {
       name: "Movies",
       extension: ""
     }
   ];
   benchMarkSelection = [];



typesOfShoes: string[] = ['Edad', 'Genero', 'Generacion', 'Localidad'];
demograficosSeleccionados:string[]=[];
geograficosSeleccionados:string[]=[];
estructuralSeleccionados:string[]=[];
HierarchicalPathsSeleccionados:any[]=[];
preguntasSeleccionados:string[]=[];
tamanoSeleccionada:string;
sectorSeleccionada:string;
RangoSelecc:any;
SectorSelecc:any;
RegionalSelecc:any;
radioSelected:string[]=[];
saveDemografResult:any;
array:string[]=[];
demografSel:string[]=[];
benckmarkSel:string[]=[];
tipobenckmarkRank:string[]=[];
tipobenckmarkSector:string[]=[];
preguntasEncuesta:any[]=[];
geograficSel:string[]=[];
structuSel:string[]=[];
Hierarchi:any[]=[];
repuestaDemograficos:any;
formGroupDemo: FormGroup;
cargando=true;
SinHierarchi=true;
rangoRankingCert3:any;
rangoRankingCert3Text: any;
displayedColumns: string[] = ['icon','position','select'];
 dataSource: any;
 selection = new SelectionModel<PeriodicElement>(true, []);
 indicador:number=0;
   @ViewChild(MatPaginator) paginator: MatPaginator;

   nombrePlantilla:any;
   fechaCertificar:any;
   rankingType:any;
   rankingName:any;
   oportunity_id:any;
   oportunity_name:any;
   fullName:any;
   email:any;
   nombreEmpresa:any;
   yearRanking:any;
   rankingEnabled:any;
   rankingRange:any;
   cssId:any;
   idPaquete:any;
   tipoProducto:any;
   rankingItem:any;
   country_application:any;
   indexMatTab=0;
   columnas:any[] = catCamposGoFlow.CAMPOS_GOFLOW;
   datasets: FormGroup[] = [];
   formValido: boolean;
   catalogos: any;
   charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
   charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
   charIdiomas = this.charChinos + this.charTurcos;
   regexAlfabetico = new RegExp("^[" + this.charIdiomas + "a-zA-Z  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
   regexAlfanumerico = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
   regexNumerico = new RegExp("^[0-9]+$");
   regexDecimalNumerico = /^\d+\.\d{2,2}$/
   regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  infoGoFlow:any;
  actualizando:boolean;
  institutos: any;
  actualizarInfoSQL:false;

  zonasUTC = zonasUTC;
  indiceZona: any;

  typeBenchMarkRank:any[]=[];
  typeBenchMarkSector:any[]=[];
  typeBenchMarkRegional:any[]=[];

  typeBenchMarkRankCopy:any[]=[];
  typeBenchMarkSectorCopy:any[]=[];
  typeBenchMarkRegionalCopy:any[]=[];

  busquedaLiaders="";
  benchMarkTypeSelect:string;
  matExpandTop:boolean=true;
  matExpandSect:boolean=false;
  matExpandRang:boolean=false;
  benchmarckSugeridosFav:any[]=[];
  matExpandCategorias:any[]=[];
  respaldoCategorias:any[]=[];
  idsDrapDrop=[];
  idsDrapDropGral=[];
  contadorLimitPuntos=0;
  noAplicBenchmark:boolean=false;
  porcentaje=0;
  labelCircleProgress:any;
  respSiNoAplicaBenchMark: number;
  opcionResp: any[]=[];
  typeOfResultsId: string;
  typeOfResults:any;
  constructor(
  @Inject(MAT_DIALOG_DATA) public datos: any,
  public dialogRef: MatDialogRef<ConfigResultComponent>,
  private _odsService: ODSService,
  private _OdsV2Service: OdsV2Service,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,
  private snackBar: MatSnackBar,
  private dateAdapter: DateAdapter<Date>
) {
  this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  lang_conteos.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_resultados.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_ods.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });

  lang_avances.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });

  lang_perfiles.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });


}


  ngOnInit() {
    console.log("limitPuntos",this.contadorLimitPuntos);
    console.log("globalLimitPuntos",globalLimitPuntos);
// this.indicador=1;
    console.log('datos',this.datos);
    if (this.datos.tipo=='confResult') {
      // this.getDemograficosResult();
      // this.getHerachicalP();

      // this.getsaveDemografResultados();
      // this.getEnterpriseDetail(this.datos.empresaId);
      this.getMyBenchMarksSaves();
      setTimeout(() => {
        this.getCatalogoBenchMark();
      }, 1000);

      this.labelCircleProgress=this.translateSrv.instant("CONFING_RESUL.LABE_CIRC_PROGRE");
      this.opcionResp=[{'text':this.translateSrv.instant("CONFING_RESUL.RES_SI"), 'value': 1},{'text':this.translateSrv.instant("CONFING_RESUL.RES_NO"), 'value': 2}];
    }

    if (this.datos.tipo=='infoProduct') {
      this.nombreEmpresa=this.datos?.nombreEmpresa;
      this.nombrePlantilla=this.datos.InfoGral?.nombrePlantilla;
      this.fechaCertificar=this.datos.InfoGral?.fechaCertificar;
      this.rankingType=this.datos.InfoGral?.rankingType;
      this.rankingName=this.datos.InfoGral?.rankingName;
      this.yearRanking=this.datos.InfoGral?.yearRanking;
      this.oportunity_id=this.datos.InfoGral?.oportunity_id;
      this.oportunity_name=this.datos.InfoGral?.oportunity_name;
      this.fullName=this.datos.InfoGral.project_manager_id?.fullName;
      this.email=this.datos.InfoGral.project_manager_id?.email;
      this.idPaquete=this.datos.InfoGral?.idPaquete;
      this.typeOfResultsId=this.datos.InfoGral?.typeOfResults;
      console.log("this.typeOfResultsId",this.typeOfResultsId);

      let rankingEnabled: string;
      let rankingRange: string;
      let cssId: string;
      let tipoPro: string;
      if (this.datos.InfoGral.rankingEnabled!="") {
        this.translateSrv.get('PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.RANKING.'+this.datos.InfoGral.rankingEnabled+'.NOMBRE').subscribe((res: string) => { rankingEnabled = res; });
      }
      this.translateSrv.get('PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.RANKING.'+this.datos.InfoGral.rankingEnabled+'.TIPO.'+this.datos.InfoGral.rankingEnabled).subscribe((res: string) => { rankingRange = res; });
      this.translateSrv.get('CONSULTATABLA.'+this.datos.InfoGral.cssId).subscribe((res: string) => { cssId = res; });
      this.translateSrv.get('CONSULTATABLA.PRODUCTOS.'+this.datos.InfoGral.idProducto).subscribe((res: string) => { tipoPro = res; });
      this.rankingEnabled=rankingEnabled;
      // this.rankingRange=rankingRange;
      this.cssId=cssId;
      this.tipoProducto=tipoPro;
      this.getRankigRangeColaboradores();
      this.getCatalogo_typeOfResults(localStorage.getItem('instituto_correos'));

    }

    if (this.datos.tipo=='goFlow') {
      this.getDataResultsGoFlow();
      this.creaFormGroups();
      this.getInstitutosVer2();
      this.indiceZona = this.zonasUTC.find(item => item.instituto == this.datos.instituto);
      console.log(this.indiceZona);

    }

  }

  drop(event: CdkDragDrop<string[]>,tipo?:string) {
    console.log(event);
    console.log(tipo);
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      // console.log("nel no es igual");
      if (tipo=="2") {
        if (this.noAplicBenchmark==false) {
          if (this.benchMarkSelection.length==0) {
            if (this.contadorLimitPuntos+event.item.data.Peso<=globalLimitPuntos) {
              this.contadorLimitPuntos=this.contadorLimitPuntos+event.item.data.Peso;
              this.indicador=this.contadorLimitPuntos;
              console.log('contadorLimitPuntos',this.contadorLimitPuntos);
              this.calculaporcenBench();
              transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
              }else{
                this.mensajeSwal(this.translateSrv.instant("CONFING_RESUL.MOD_WARN_MAX_PERMIT"), 2);
              }
            }else{
              let existBenchMark=this.benchMarkSelection.findIndex(item=>item.BenchmarkType== event.item.data.BenchmarkType);
              // if (existBenchMark!=-1) {
                //   this.mensajeSwal(this.translateSrv.instant("CONFING_RESUL.MOD_WARN_UN_CATE"), 2);
                // }else{
                  if (this.contadorLimitPuntos+event.item.data.Peso<=globalLimitPuntos) {
                    this.contadorLimitPuntos=this.contadorLimitPuntos+event.item.data.Peso;
                    console.log('contadorLimitPuntos',this.contadorLimitPuntos);
                    this.indicador=this.contadorLimitPuntos;
                    transferArrayItem(event.previousContainer.data,
                      event.container.data,
                      event.previousIndex,
                      event.currentIndex);
                      this.calculaporcenBench();
                    }else{
                      this.mensajeSwal(this.translateSrv.instant("CONFING_RESUL.MOD_WARN_MAX_PERMIT"), 2);
                    }
                    // }

                  }
        }else{
          this.mensajeSwal(this.translateSrv.instant("CONFING_RESUL.MOD_WARN_NO_APLIC"), 2);
        }
      }else{
        let indexCategoria=this.matExpandCategorias.findIndex(item=>item.catego==event.item.data.BenchmarkType);
        if (indexCategoria!=-1) {
          this.matExpandCategorias[indexCategoria].datos.push(event.item.data);
          console.log('contadorLimitPuntos',this.contadorLimitPuntos);
          this.contadorLimitPuntos=this.contadorLimitPuntos-event.item.data.Peso;
          this.indicador=this.contadorLimitPuntos;
          transferArrayItem(event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);
          }
        }
        this.calculaporcenBench();

      }
    }

demoPrueba(event:any){
  console.log("event",event);

}


  creaFormGroups(){
    let dataSetActual = 0;
    let group = {};
    this.columnas.forEach(columna => {
      if(columna.visible){
        if(dataSetActual != columna.dataset){
          if(dataSetActual > 0){
            if(dataSetActual == 1){ //si acaba de pasar al segundo formulario y es instituto tr o hk, agrega el formcontrol surveykey al primer formulario
              // if(this.instituto_id == "3" || this.instituto_id == "5"){
              //   group['surveyKey'] = new FormControl('');
              // }
            }
            this.datasets.push(new FormGroup(group) );
          }
          dataSetActual = columna.dataset;
          group = {};
        }

        switch (columna.clave) {
          default:
            group[columna.clave] = new FormControl('');
        }
      }
    });
    //inserta el ultimo formgroup
    this.datasets.push(new FormGroup(group) );
    console.log("formgroups:",this.datasets);





    this.datasets.forEach((dataset,i) => {
      dataset.valueChanges.subscribe( (res) => {
        // console.log("dataset",i,":",dataset.status);

        if(dataset.status == 'VALID'){
          this.formValido = this.formValido && true;
        }
        else{
          this.formValido = this.formValido && false;
        }
      });
    });
  }

  llenaInfoColaborador(){
    this.datasets.forEach((dataset,i) => {
      for(let k in this.infoGoFlow){
        if(dataset.controls.hasOwnProperty(k)){
            dataset.controls[k].setValue(this.infoGoFlow[k]);
        }
      }
    });
    // this.llenaCamposValorVariable();
  }

  validarDato(dato:any,tipoValidacion:string,numCampo:number,columna:any){
    let datoCorrecto = true;

    if (columna!="company_Country") {
    switch (tipoValidacion) {
      case "alfabetica":
        datoCorrecto = this.regexAlfabetico.test(dato.target.value);
      break;
      case "alfanumerica":
        datoCorrecto = this.regexAlfanumerico.test(dato.target.value);
      break;
      case "Decimal":
        datoCorrecto = this.regexDecimalNumerico.test(dato.target.value);
      break;
      case "email":
        if(dato.target.value == "*"){
          datoCorrecto = true;
        }
        else{
          datoCorrecto = this.regexEmail.test(dato.target.value);
        }
      break;
      case "numerica":
        datoCorrecto = this.regexNumerico.test(dato.target.value);
      break;
    }
  }
    console.log("dato:",dato.target.value," tipoVal:",tipoValidacion," resultado:",datoCorrecto);

    if(!datoCorrecto){

      this.mensajeSwal(this.translateSrv.instant('AVANCES.FORMULARIO_GO_FLOW.WARNI_TI_DA'), 2);
      // this.datasets[this.columnas[numCampo].dataset - 1].controls[this.columnas[numCampo].clave].setValue('');
    }
    else{
          this.actualizando=true;
        let datos={
          productoId:this.datos.InfoGral.idCertificar,
        }
        if (columna=="pdf_DateCreation") {
          let fechaActual = momentTz.tz(this.indiceZona.zona).utc(true);
          let fecha=moment(dato.target.value).format('YYYY-MM-DD')+' '+ moment().format('HH:mm');
          let diferenciaMinutos = moment().diff(fechaActual, 'seconds');
          let fechaActualTransformada = momentTz.tz(fecha,this.indiceZona.zona).add(diferenciaMinutos, 'seconds');
          // console.log('fecha',fecha);
          // console.log('this.indiceZona',this.indiceZona);
          // console.log('momentTz(fecha,this.indiceZona.zona)',momentTz.tz(fecha,this.indiceZona.zona));
          // console.log('diferenciaMinutos',diferenciaMinutos);
          datos[columna] = fechaActualTransformada.utc(true).toISOString();
        }else{
          datos[columna] = dato.target.value;
        }
        console.log('Datos antes de enviar:',datos);

      this._odsService.saveDataResultsGoFlow(this.datos.empresaId,datos).subscribe( (respuesta: any) => {
      console.log('Respuesta',respuesta);
      this.actualizando=false;
      this.getFlagResultsGoFlow();

    });

    }
  }

  getDataResultsGoFlow(){
    this._odsService.getDataResultsGoFlow(this.datos.empresaId,this.datos.InfoGral.idCertificar).subscribe( (respuesta: any) => {
    console.log('Respuesta getDataResultsGoFlow',respuesta);
    this.infoGoFlow=respuesta.resultsGoFlow;
    this.actualizarInfoSQL= respuesta.resultsGoFlow.sendSQL;
    if(this.infoGoFlow){
      this.llenaInfoColaborador();
    }

  });
  }

  getFlagResultsGoFlow(){
    this._odsService.getDataResultsGoFlow(this.datos.empresaId,this.datos.InfoGral.idCertificar).subscribe( (respuesta: any) => {
    console.log('Respuesta getDataResultsGoFlow',respuesta);
    this.actualizarInfoSQL= respuesta.resultsGoFlow.sendSQL;
  });
  }



  getDemograficosResult() {
  console.log('Instituto de la empresa',localStorage.getItem('instituto_correos'));

    this._odsService.getDemografResult(localStorage.getItem('instituto_correos'),this.datos.tokenConfig).subscribe(response => {
      console.log('response',response);
      this.repuestaDemograficos=response;
      this.repuestaDemograficos.catConfig.forEach(valueType => {
        if (valueType.valueTypeId==1 && valueType.survey==2) {
          this.demografSel.push(valueType);
        }
        if (valueType.valueTypeId==5 &&  valueType.BenchmarkType=='Rank') {
          this.tipobenckmarkRank.push(valueType);
        }else if(valueType.valueTypeId==5 &&  valueType.BenchmarkType=='Sector'){
          this.tipobenckmarkSector.push(valueType);
        }
        if (valueType.valueTypeId==2) {
          this.structuSel.push(valueType);
        }

        if (valueType.valueTypeId==3) {
          this.geograficSel.push(valueType);
        }

        if (valueType.survey==1) {
          this.preguntasEncuesta.push(valueType);
        }

      });
      console.log('DemografSel ',this.demografSel);
      console.log('tipobenckmarkRank ',this.tipobenckmarkRank);
      console.log('tipobenckmarkSector ',this.tipobenckmarkSector);
      console.log('geograficSel ',this.geograficSel);
      console.log('StructuSel ',this.structuSel);
      console.log('preguntasEncuesta ',this.preguntasEncuesta);



    }, error => {
      console.log("error", error);
    })
  }



  getsaveDemografResultados() {
  console.log('Instituto de la empresa',localStorage.getItem('instituto_correos'));

    this._odsService.getsaveDemografResult(this.datos.empresaId,this.datos.tokenConfig).subscribe(response => {
      console.log('response',response);
      this.saveDemografResult=response;
      this.saveDemografResult.array.forEach(filtrosGuardados => {
        if (filtrosGuardados.valueTypeId==1 && filtrosGuardados.survey==2) {
          this.demograficosSeleccionados.push(filtrosGuardados.key)
        }
        if (filtrosGuardados.valueTypeId==2) {
          this.estructuralSeleccionados.push(filtrosGuardados.key)
        }
        if (filtrosGuardados.valueTypeId==3) {
          this.geograficosSeleccionados.push(filtrosGuardados.key)
        }
        if (filtrosGuardados.valueTypeId==1 && filtrosGuardados.survey==1) {
          this.preguntasSeleccionados.push(filtrosGuardados.key)
        }
        if (filtrosGuardados.valueTypeId==5 && filtrosGuardados.BenchmarkType=="Rank") {
        this.tamanoSeleccionada=filtrosGuardados.key;
        }
        if (filtrosGuardados.valueTypeId==5 && filtrosGuardados.BenchmarkType=="Sector") {
        this.sectorSeleccionada=filtrosGuardados.key;
        }
      });
      console.log('this.demograficosSeleccionados::::::::::',this.demograficosSeleccionados);
      console.log('this.preguntasSeleccionados::::::::::',this.preguntasSeleccionados);

    }, error => {
      console.log("error", error);
    })
  }

  saveDemografResultados() {
  let datos={empresaId:this.datos.empresaId,surveyToken:this.datos.tokenConfig,array:this.array};
  console.log('datos antes de enviar',datos);
  let mensaje = 'CONFING_RESUL.CONFI_GUAR_SELE';
  let respSi = 'CONFING_RESUL.RES_SI';
  let respNo = 'CONFING_RESUL.RES_NO';
  this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
  this.translateSrv.get(respSi).subscribe((res: string) => { respSi = res; });
  this.translateSrv.get(respNo).subscribe((res: string) => { respNo = res; });
  Swal.fire({
  title: mensaje,
  icon: 'warning',
  showCancelButton: true,
reverseButtons: true,


  confirmButtonText: respSi,
  cancelButtonText: respNo
}).then((result) => {
  if (result.value) {
    this.modalGuardado();
    if (this.array.length>0 && this.selection.selected.length>0) {
      this.HierarchicalPathsSeleccionados=[];
      this.HierarchicalPathsSeleccionados= [...this.HierarchicalPathsSeleccionados,...this.selection.selected];
      console.log("guarda ambos resultados  *******");
      console.log('HierarchicalPathsSeleccionados',this.HierarchicalPathsSeleccionados);
      this._odsService.saveDemografResult(datos).subscribe(response => {
        console.log('response',response);
        this.getsaveDemografResultados();
        this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
        this.saveHerachicalP();
      }, error => {
        console.log("error", error);
      })

    }else if(this.array.length==0 && this.selection.selected.length>0){
    console.log("guarda unicamente HierarchicalPaths");
    this.HierarchicalPathsSeleccionados=[];
    this.HierarchicalPathsSeleccionados= [...this.HierarchicalPathsSeleccionados,...this.selection.selected];
    console.log('HierarchicalPathsSeleccionados',this.HierarchicalPathsSeleccionados);
    this.saveHerachicalP();

    }else if(this.array.length>0 && this.selection.selected.length==0){
      console.log("guarda resultados demograficos");
      this._odsService.saveDemografResult(datos).subscribe(response => {
      console.log('response',response);
        Swal.close();
        this.getsaveDemografResultados();
        this.dialogRef.close();
        this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
      }, error => {
        console.log("error", error);
      })

    }
  }
});

  }
  modalGuardado(){
    let mensaje: string;

        this.translateSrv.get('CONFING_RESUL.MODAL_GUA_INFOR').subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }
  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

salir(index) {
  console.log('this.indexMatTab',this.indexMatTab);
  if (this.indexMatTab===0) {
    if(this.rangoRankingCert3!=parseInt(this.datos.infoProducto.rankingRange)){
  let mensaje = 'CONFING_RESUL.CONFI_GUAR_SELE';
  let respSi = 'CONFING_RESUL.RES_SI';
  let respNo = 'CONFING_RESUL.RES_NO';
  this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
  this.translateSrv.get(respSi).subscribe((res: string) => { respSi = res; });
  this.translateSrv.get(respNo).subscribe((res: string) => { respNo = res; });
  Swal.fire({
  title: mensaje,
  icon: 'warning',
  showCancelButton: true,
  reverseButtons: true,
  confirmButtonText: respSi,
  cancelButtonText: respNo
}).then((result) => {
  if (result.value) {
    this.modalGuardado();

      const datosBench = {productoId: this.datos.productoId,rankingRange:this.rangoRankingCert3};
      const datos = {empresaId: this.datos.empresaId,productoId: this.datos.productoId};
      console.log('El bench mark es diferentes, se ejecuta la funcion que actualiza ',datosBench);

    this._odsService.updateBenchMark(this.datos.empresaId,datosBench).subscribe((respuestaBench:any) => {
      console.log('respuestaBench',respuestaBench);

    if (respuestaBench.success) {
         this._odsService.updateMasterTable(datos).subscribe((respuesta:any) => {
          if(respuesta.success){
              Swal.close();
              this.dialogRef.close();
            }else{
              Swal.close();
            }
          });
    }
});
}
});
    }
  }else{
    this.array=[];
    console.log('demograficosSeleccionados',this.demograficosSeleccionados);
    console.log('geograficosSeleccionados',this.geograficosSeleccionados);
    console.log('estructuralSeleccionados',this.estructuralSeleccionados);
    console.log('preguntasSeleccionados',this.preguntasSeleccionados);
    console.log('tamanoSeleccionada',this.tamanoSeleccionada);
    console.log('sectorSeleccionada',this.sectorSeleccionada);

    // if (this.demograficosSeleccionados.length>0) {
      this.repuestaDemograficos.catConfig.forEach(tipoDemograf => {
        this.demograficosSeleccionados.forEach(keySeleccionado => {
          if (tipoDemograf.key==keySeleccionado && tipoDemograf.survey==2) {
            this.array.push(tipoDemograf);
          }
        });

        this.geograficosSeleccionados.forEach(keySeleccionado => {
          if (tipoDemograf.key==keySeleccionado) {
            this.array.push(tipoDemograf);
          }
        });

        this.estructuralSeleccionados.forEach(keySeleccionado => {
          if (tipoDemograf.key==keySeleccionado) {
            this.array.push(tipoDemograf);
          }
        });

        this.preguntasSeleccionados.forEach(keySeleccionado => {
          if (tipoDemograf.key==keySeleccionado && tipoDemograf.survey==1) {
            this.array.push(tipoDemograf);
          }
        });

        if(tipoDemograf.key==this.tamanoSeleccionada){
          this.array.push(tipoDemograf);
        }
        if(tipoDemograf.key==this.sectorSeleccionada){
          this.array.push(tipoDemograf);
        }

      });
      console.log('this.array::',this.array);

      this.saveDemografResultados();

      // }else{
        //   this.dialogRef.close();
        // }
  }


  }
salirOk() {
  this.dialogRef.close();
  }


  isAllSelected() {
     const numSelected = this.selection.selected.length;
     const numRows = this.dataSource.data.length;
     return numSelected === numRows;
   }

   masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        console.log('this.dataSource.data',this.dataSource.data);

        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    // console.log('row',row);
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  getHerachicalP(){
      this._odsService.getHerachicalPa(this.datos.tokenConfig).subscribe((response:any) => {
        console.log('response',response);
        this.Hierarchi=response.records;
        if (this.Hierarchi.length==0) {
          this.SinHierarchi=false;
        }else{
          this.SinHierarchi=true;
        }
        this.dataSource = new MatTableDataSource<any>(this.Hierarchi);
        this.getHerachicalPGuardados();
        setTimeout(() => {
        this.dataSource.paginator = this.paginator;
      }, 2000);
      }, error => {
        console.log("error", error);
      })
    }

  getHerachicalPGuardados(){
      this._odsService.getHerachicalPaGuardados(this.datos.tokenConfig).subscribe((response:any) => {
        console.log('response',response);
        if (response.records.length>0) {

          // this.dataSource.data=response.records;
          response.records.forEach(hierarchiGua => {
            this.dataSource.data.forEach(row => {
              if (hierarchiGua.RowIdReference== row.rowid) {
                console.log('lo encontro');

                this.selection.select(row);
              }
                });

          });

            }

      }, error => {
        console.log("error", error);
      })
    }

  saveHerachicalP(){
    let datos={
      records: this.HierarchicalPathsSeleccionados,
    }
    console.log('datos************',datos);

      this._odsService.savetHerachicalPa(this.datos.tokenConfig,datos).subscribe((response:any) => {
        console.log('response',response);

          Swal.close();
          this.dialogRef.close();
      }, error => {
        console.log("error", error);
      })
    }

    getRankigRangeColaboradores(){
      this._odsService.getRankigRangeColab(localStorage.getItem('instituto_correos'),this.translateSrv.currentLang).subscribe((response:any) => {
        console.log('nuevo servicio response',response);
        response.result.forEach(tipoRange => {
          if (tipoRange.SizeID==parseInt(this.datos.InfoGral.rankingRange)) {
            this.rankingRange=tipoRange.SizeText;
          }
        });
console.log('this.rankingRange',this.rankingRange);

      }, error => {
        console.log(error);
      });
    }

  getEnterpriseDetail(idEnterprise : string) {
      this._odsService.getEnterpriseDetail(idEnterprise).subscribe((response:any) => {
        console.log("getEnterpriseDeailt");
        console.log(response);

        this.country_application= response.data.country_application;

        this.getCatalogoRangoColaboradoresV1(this.country_application);


      }, error => {
        console.log("error", error);
      });
    }

    getCatalogoRangoColaboradoresV1(country){
      this._odsService.getCatalogoRangoColaboradores(localStorage.getItem('instituto_correos'),this.translateSrv.currentLang,country).subscribe((respuesta:any) => {
        console.log("getCatalogoRangoColaboradores:",respuesta);
        this.rankingItem = respuesta.result;

        this.rangoRankingCert3= parseInt(this.datos.infoProducto.rankingRange);
        console.log('rangoRankingCert3',this.rangoRankingCert3);
        let indiceRan= this.rankingItem.findIndex(item => item.SizeID == this.rangoRankingCert3);
        if (indiceRan!=-1) {
          this.rangoRankingCert3Text=this.rankingItem[indiceRan].SizeText;
        }
      });
    }

    salindexMatTab(indexMatTab:any){
    this.indexMatTab= indexMatTab.index;
    }

    guardaInfoGoFlow(){
      let formValido: boolean = true;
      let datosFormulario: any = {};
      var BreakException = {};
      try {
        this.datasets.forEach((dataset,i) => {
          // console.log("dataset:",dataset);
          // datosFormulario = {...dataset.value};
          // datosFormulario = Object.assign(dataset.value);
          _.merge(datosFormulario,dataset.getRawValue());
          if(dataset.status != 'VALID'){
            formValido = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
      if(formValido){
        // datosFormulario.claveProd = this.datos.tipoProducto;
        let datosFormularioPrevioMod = JSON.parse(JSON.stringify(datosFormulario));
        // datosFormulario = this.setVarsExtra(datosFormulario);
        if (datosFormulario.survey_Score_OverallTI!=0 && datosFormulario.survey_Score_Camaraderie!=0 && datosFormulario.survey_Score_Credibility!=0 && datosFormulario.survey_Score_Imparciality!=0 && datosFormulario.survey_Score_Pride!=0 && datosFormulario.survey_Score_Respect!=0) {
          console.log("datosFormulario post valido:",datosFormulario);
          Swal.fire({
            title: this.translateSrv.instant('AVANCES.NEWCOLAB.GUARDANDO_GOFLOW'),
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });
          if(this.infoGoFlow){
            let datos={productoId:this.datos.InfoGral.idCertificar}
            console.log("datosFormulario a enviar:",datosFormulario);
            this._odsService.saveDataResultsGoFlowSQL(this.datos.empresaId,datos).subscribe( (respuesta: any) => {
              console.log('Respuesta',respuesta);
              // this.actualizando=false;
              this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
              this.getFlagResultsGoFlow();
              Swal.close();
            });
              }
        }else{
            this.mensajeSwal(this.translateSrv.instant('AVANCES.FORMULARIO_GO_FLOW.WARNI_TI_DA_GRAL'), 2);
        }

      }
      else{console.log('nel');

        // this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.FORMULARIO'),2);
      }
    }


    getInstitutosVer2(){
      this._OdsV2Service.getInstitutosV2(localStorage.getItem('levelUser_tmp'),localStorage.getItem('instituto_id')).subscribe((respuesta:any) => {
        console.log("respuesta getInstitutosV2:",respuesta);
        if(respuesta.success){
          const instituto = localStorage.getItem('instituto_id');
          switch (instituto) {
            case '14':  //GCTI
              const datosInst14 = respuesta.institutos.find(item => item.numInstituto == 14);
              this.institutos = [datosInst14];
            break;
            case '18':  //AMCO
              const datosInst18 = respuesta.institutos.find(item => item.numInstituto == 18);
              this.institutos = [datosInst18];
            break;
            default:
              this.institutos = respuesta.institutos;
          }
          // this.datosCatalogos['institutoEmpresa'] = this.institutos;
        }
      });
    }

    mensajeSwal(mensaje:string, tipoMsg:number){
      let tipo: any;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      switch(tipoMsg){
        case 1: tipo = 'success'; break;
        case 2: tipo = 'warning'; break;
        case 3: tipo = 'error'; break;
      }
      Swal.fire({
        title: mensaje,
        icon: tipo,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }


    getCatalogoBenchMark(){
      this._odsService.getCatBenchMark(this.datos.instituto,this.datos.infoProducto.tokenConfig).subscribe( (respuesta: any) => {
      console.log('Respuesta getCatBenchMark',respuesta);
      this.matExpandDinamic(respuesta);

    });
    }




    getMyBenchMarksSaves(){
      this._odsService.getMyBenchMarks(this.datos.infoProducto.tokenConfig).subscribe( (respuesta: any) => {
        console.log('Respuesta getMyBenchMarksSaves',respuesta);
    if (respuesta.result.length>0) {
      let disabledResultNoApli= respuesta.result.findIndex(item=>item.BenchmarkID=="0");
      console.log('disabledResultNoApli',disabledResultNoApli);
      if (disabledResultNoApli!=-1) {
        this.noAplicBenchmark=true;
        this.respSiNoAplicaBenchMark=2;
      }else{
        this.benchMarkSelection=respuesta.result;
        this.noAplicBenchmark=false;
        this.respSiNoAplicaBenchMark=1;
      }
    respuesta.result.forEach(tipoSave => {
  this.contadorLimitPuntos=this.contadorLimitPuntos+parseInt(tipoSave.Peso);
  this.indicador=this.contadorLimitPuntos;
  });


  this.calculaporcenBench();

}else{
  this.noAplicBenchmark=false;
  this.respSiNoAplicaBenchMark=1;
}
console.log('respSiNoAplicaBenchMark',this.respSiNoAplicaBenchMark);
console.log('noAplicBenchmark',this.noAplicBenchmark);
console.log('benchMarkSelection',this.benchMarkSelection);
console.log('contadorLimitPuntos',this.contadorLimitPuntos);

      });

    }


  evenPredicate(item: CdkDrag<any>,item2:any) {
    return item.data.BenchmarkType == item2.id
  }


  GuardarBenchMar(){
    Swal.fire({
    title: this.translateSrv.instant('CONFING_RESUL.CONFI_GUAR_SELE'),
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: this.translateSrv.instant('CONFING_RESUL.RES_SI'),
    cancelButtonText: this.translateSrv.instant('CONFING_RESUL.RES_NO'),
  }).then((result) => {
    if (result.value) {
      this.benchMarkSelection.forEach((orden,i) => {
        orden.orden=i+1;
      });
      let datos={
        array:this.benchMarkSelection,
      }
      console.log("benchMarkSelection",this.benchMarkSelection);
      this.modalGuardado();
        this._odsService.SaveBenchMark(this.datos.infoProducto.tokenConfig,datos).subscribe((response: any) => {
          if (response.success) {
            this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
            Swal.close();
          }
        }, error => {
          console.log("error", error);
        })

    }
  });
  }

  addFavoritesBenchMark(){
    if (this.benchmarckSugeridosFav.length!=0) {
      this.benchMarkSelection=this.benchmarckSugeridosFav;
    this.benchmarckSugeridosFav.forEach(benchFav => {
      let indexCategoria=this.matExpandCategorias.findIndex(item=>item.catego== benchFav.BenchmarkType);
      console.log(indexCategoria);
      if (indexCategoria!=-1) {
        let  indexElement=this.matExpandCategorias[indexCategoria].datos.findIndex(item=>item.BenchmarkID== benchFav.BenchmarkID)
          if (indexElement!=-1) {
            this.matExpandCategorias[indexCategoria].datos.splice(indexElement,1)
          }
      }
    });
    }
  }

  matExpandDinamic(datos:any){
    let catMatExpan:any[]=[];
    let data:any[]=[];
    let active:boolean;
    datos.result.forEach((catego,i) => {
      data=[];
      if (catMatExpan.length==0) {
        data.push(catego);
        catMatExpan.push({catego: catego.BenchmarkType,active:false, datos: data});
        this.idsDrapDrop.push(catego.BenchmarkType);
        this.idsDrapDropGral.push(catego.BenchmarkType);
      }else{
        let indiceCatego= catMatExpan.findIndex(item => item.catego == catego.BenchmarkType);
        if (indiceCatego==-1) {
          data.push(catego);
          catMatExpan.push({catego: catego.BenchmarkType,active:false, datos: data})
          this.idsDrapDrop.push(catego.BenchmarkType);
          this.idsDrapDropGral.push(catego.BenchmarkType);
        }else{
          catMatExpan[indiceCatego].datos.push(catego);
        }
      }
    });
    this.matExpandCategorias=catMatExpan;
    this.matExpandCategorias.sort( (a,b) => { if(a.catego > b.catego){ return 1; } else{ return -1; } });
    this.matExpandCategorias[0].active=true;
    this.matExpandCategorias.forEach((cata,n) => {
      cata.datos.forEach((data,i) => {
        // if (data.BenchmarkType=="Rank") {
          // console.log(data);
          data.text = data.text!=null ? data.text.split(',').join("\r\n"):null;
          // console.log(data);
        // }


      this.matExpandCategorias[n].datos.sort( (a,b) => { if(a.DefaultID < b.DefaultID){ return 1; } else{ return -1; } });
        if (data.DefaultID!=0) {
          this.benchmarckSugeridosFav.push(data);
        }
      });
    });

    console.log('this.matExpandCategorias',this.matExpandCategorias);
    this.respaldoCategorias=JSON.parse(JSON.stringify(this.matExpandCategorias));
    // console.log("respaldoCategorias",this.respaldoCategorias);
    console.log("benchMarkSelection",this.benchMarkSelection);
    this.benchMarkSelection.forEach(tipoSave => {
      console.log('BenchmarkType',tipoSave.BenchmarkType);

      let indexCatBench=this.matExpandCategorias.findIndex(item=>item.catego==tipoSave.BenchmarkType);
      if (indexCatBench!=-1) {
        console.log("indexCatBench",indexCatBench);
        let indexBenchSave=this.matExpandCategorias[indexCatBench].datos.findIndex(item=>item.BenchmarkID==parseInt(tipoSave.BenchmarkID));
        if (indexBenchSave!=-1) {
          // tipoSave.text=this.matExpandCategorias[indexCatBench].datos[indexBenchSave].text;
          console.log("indexBenchSave",indexBenchSave);

          this.matExpandCategorias[indexCatBench].datos.splice(indexBenchSave,1);
        }
      }

    });
this.cargando=false;
console.log(this.benchMarkSelection);

// this.actionMatExpand(null);
  }

  actionMatExpand(tipo){
    console.log("tipo",tipo);

    this.matExpandCategorias.forEach((matCat,i) => {
      // if (i==0) {
      //   matCat.active=true;
      // }else{
        if (matCat.catego== tipo){matCat.active=true}else{matCat.active=false;}
      // }
    });
  }

  BenchMarkapplyFilter(filterValue: string,cate) {
let indiceCat= this.matExpandCategorias.findIndex(item=>item.catego==cate);
  if (indiceCat!=-1) {
    let referenciaTipo=JSON.parse(JSON.stringify(this.respaldoCategorias[indiceCat].datos));
    this.matExpandCategorias[indiceCat].datos=referenciaTipo.filter(u => u.NombreBenchmark.toLowerCase().includes(filterValue.toLowerCase()));
  }
  }

  updateNoAplicBenchMark(opcion:any,event){
    console.log('noAplicBenchmark',this.noAplicBenchmark);

      // Swal.fire({
      //   title: this.translateSrv.instant('CONFING_RESUL.CONFI_GUAR_SELE'),
      //   icon: 'warning',
      //   showCancelButton: true,
      //   reverseButtons: true,
      //   confirmButtonText: this.translateSrv.instant('CONFING_RESUL.RES_SI'),
      //   cancelButtonText: this.translateSrv.instant('CONFING_RESUL.RES_NO'),
      // }).then((result) => {
      //   console.log(result);

        // if (result.value) {
      if (opcion==2) {
        let datos={
          array:[{
            "NombreBenchmark": "No Aplica",
            "BenchmarkID": 0,
            "BenchmarkType": "No Aplica",
            "Peso": 0,
            "text": "No Aplica",
            "DefaultID": 0,
            "orden":0}],
          }
          this.modalGuardado();
          this._odsService.SaveBenchMark(this.datos.infoProducto.tokenConfig,datos).subscribe((response:any) => {
            if (response.success==true) {
              this.noAplicBenchmark=true;
              this.respSiNoAplicaBenchMark=2;
              this.benchMarkSelection=[];
              this.contadorLimitPuntos=0;
              this.indicador=0;
              this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
              Swal.close();

            }else{
              setTimeout(() => {
                this.noAplicBenchmark=false;
                this.respSiNoAplicaBenchMark=1;
              }, 1000);

            }
          }, error => {
            console.log("error", error);
          })

        }else{
            this.modalGuardado();
            this._odsService.deleteBenchMarkNoAplic(this.datos.infoProducto.tokenConfig).subscribe((response:any) => {
              if (response.success==true) {
                this.noAplicBenchmark=false;
                this.respSiNoAplicaBenchMark=1;
                this.openSuccessSnackBar(this.translateSrv.instant('CONFING_RESUL.SUCCES_GUAR_SELEC'),'');
                Swal.close();
              }else{
                setTimeout(() => {
                  this.noAplicBenchmark=true;
                  this.respSiNoAplicaBenchMark=2;
                }, 1000);

              }
            }, error => {
              console.log("error", error);
            })
        }

          // }else{
          //   if (result.dismiss) {
          //     setTimeout(() => {
          //       console.log('entro entro entro');
          //       this.noAplicBenchmark=!event["checked"];
          //     }, 1000);
          //   }
          // }
        // });


  }

  calculaporcenBench(){
    if (this.contadorLimitPuntos==10) {
      this.porcentaje=100;
    }else{
      let contador=this.contadorLimitPuntos.toString();
      contador=contador.padEnd(2, '0');
      console.log(contador);
      this.porcentaje=parseInt(contador);
    }


  }

  getCatalogo_typeOfResults(broker) {
    this._odsService.getCat_typeOfResults(broker).subscribe((response:any) => {
      console.log('response getCat_typeOfResults',response);
      this.typeOfResults=response.result;
     // this.rankings = response.Seleccion;
    }, error => {
      //console.log("error", error);
    })
  }

  saveTypeResults(){
this.modalGuardado();
    let datos={
      typeOfResults_id:this.typeOfResultsId,
    }
    console.log("typeOfResultsId",this.typeOfResultsId);
    this._odsService.update_typeOfResults(this.datos.empresaId,this.datos.InfoGral?.idCertificar,datos).subscribe((response:any) => {
      console.log('response getCat_typeOfResults',response);
      Swal.close();
      // this.typeOfResults=response.result;
     // this.rankings = response.Seleccion;
    }, error => {
      //console.log("error", error);
    })
  }
}
